module.exports = __webpack_public_path__ + "static/media/userLogo.6f6bbb16.png";